import {fabric} from 'fabric';
import {AbstractShapeFactory} from './AbstractShapeFactory';
import {WBUtils} from '../util/WBUtils';

export class RectangleFactory extends AbstractShapeFactory {

  constructor() {
    super();
    this.awType = 'rectangle';
    this.parentButton = WBUtils.buttonBasic;
  }

  /**
     * Creates and returns a fabric rectangle object at position (anchorX/anchorY) and sets
     * the attriubtes color, fill and stroke
     */
  public create(anchorX: number, anchorY: number, color: string, fill: string, stroke: number): any {
    this.shapeObject =  new fabric.Rect({
      width: 5,
      height: 5,
      left: anchorX,
      top: anchorY,
      stroke: color,
      strokeWidth: stroke,
      fill: fill,
      selectable: false
    });

    return this.shapeObject;
  }

  /**
     * modifies the rectangle object expanding it to position (eventX/eventY), also checks
     * the direction of movement with position (anchorX, anchorY).
     */
  public modify(anchorX: number, anchorY: number, eventX: number, eventY: number) {
    if (anchorX > eventX) {
      this.shapeObject.set({ left: Math.abs(eventX) });
    }
    if (anchorY > eventY) {
      this.shapeObject.set({ top: Math.abs(eventY) });
    }
    this.shapeObject.set({ width: Math.abs(anchorX - eventX) });
    this.shapeObject.set({ height: Math.abs(anchorY - eventY) });
  }

  /**
     * Executes the copy method of the AbstractShapeFactory
     */
  public copyAndDrop(id: number, awtype: string, callback: (clone) => void) {
    this.copy(id, awtype, callback);
  }

}
